import { TypeMappingOverview } from './type-mapping-overview';

export class TypeMappingEstimation {
     eventsTotal: number = 0;
     storeSize: number = 0;
     eventsAverageSize: number = 0;
     estimatedStoreSize: number = 0;
     estimateStoreSizeWarning: boolean = false;
     estimatedRetentionPeriodInSeconds: number;
          

     constructor(tmo: TypeMappingOverview, availableSpaceInBytes: number, maximumEventsPerType: number) {
          this.storeSize = tmo.storeSize;
          this.eventsTotal = tmo.eventsTotal;
          this.eventsAverageSize = tmo.storeSize / tmo.eventsTotal;
          this.estimatedStoreSize = maximumEventsPerType * (this.eventsAverageSize);
          if (this.estimatedStoreSize >= availableSpaceInBytes) {
               this.estimateStoreSizeWarning = true;
          }
          this.estimatedRetentionPeriodInSeconds = maximumEventsPerType/tmo.eventsPerSec;
     }
}